import $http from "../../axios";
import * as mutations from './mutations'
import {Notification} from "element-ui";

export async function downloadProductsTemplate({state}) {
    let name = 'inventarios_ideales.xlsx';
    state.message_loading = 'Descargando Plantilla De Inventarios Ideales';
    state.loading = true;

    try {
        const response = await $http({
            url: '/api/descargar-plantilla-inventarios-ideales',
            method: 'GET',
            responseType: 'blob',
        });

        state.loading = false;

        // Crea un enlace para descargar el archivo
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', name);
        document.body.appendChild(link);
        link.click();

        // Elimina el enlace después de la descarga
        link.remove();
    } catch (error) {
        state.loading = false;
        Notification.error({
            title: 'Error!',
            message: error.message,
            type: 'error',
            duration: 3000,
            customClass: 'notification-box',
        });
    }
}

/**
 * Envio petición para generar el carge de la plantilla de inventarios ideales
 */
export async function uploadIdealBalancesTemplate ({state, commit}) {
    let formData = new FormData();
    formData.append('file', state.file);
    commit('setMessageLoading', 'Cargando Plantilla De Inventarios Ideales');
    commit('setLoading', true);
    $http.post(`/api/cargar-plantilla-inventarios-ideales`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(function(){
        Notification.success({
            title: "Success!",
            message: 'Archivo cargado',
            type: "success",
            duration: 3000,
            customClass: "notification-box"
        });
    }).catch(error => {
        Notification.error({
            title: "Error!",
            message: error.message +' Verifique el archivo sea un csv delimitado por punto y coma (;) y que corresponda a la información de la plantilla',
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    }).finally(() => {
        commit('setLoading', false);
    });
}



// WEBPACK FOOTER //
// ./src/modules/import-ideal-balances/actions.js